import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	//首页
	{
		path: '/',
		name: 'index',
		component: () => import('../views/index.vue')
	},
	//欢迎页
	{
		path: '/home',
		name: 'home',
		component: () => import('../views/home.vue')
	},
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

export default router
